import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

import * as Objects from '@core/objects'
import * as Search from '@app/models/search';


interface SearchAvailableEventsFilters extends Search.SearchAvailableFilters {
    items: Array<Objects.EventTrack>;
}
@Component({
    selector: 'app-helpers-search-filters-logbook-events-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class HelpersSearchFiltersLogbookEventsMainComponent implements OnInit, OnChanges{

    @Input()  available: SearchAvailableEventsFilters = null;
    @Input()  applied: Array<Search.SearchAppliedFilter> = [];

    @Output() apply = new EventEmitter<Search.SearchAppliedFilter>();

    public events : Objects.EventTrack[] = [];

    ngOnInit(): void {
       this.makeEvents();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.applied)
            this.makeEvents();
    }

    onSelect(event: Objects.EventTrack) {
        this.apply.emit({key: this.available.key,item: event});
    }

    private isApplied(event: Objects.EventTrack) : boolean {
        return this.applied.some((f: Search.SearchAppliedFilter) => f.key == this.available.key && f.item.id == event.id);
    }

    private makeEvents(): void {
        this.events = this.available.items.filter((event: Objects.EventTrack) => !this.isApplied(event));
    }

}
